  export enum ProjectType {
    PROJECT = "PROJECT",
    LOAN = "LOAN"
  }
